import {
    HTMLAttributes,
    ReactElement,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
interface Props extends HTMLAttributes<HTMLElement> {
    name?: string;
    icon: any;
    link?: string;
    myStyle?: string;
    userProfile?: boolean;
    subMenu?: any;
    isMini?: boolean;
    headerStatus?: boolean;
    userData?: any
}
export function HeaderItem({ name, icon, link }: Props): ReactElement {
    const navigation = useNavigate();
    const location = useLocation();
    // Global active state — based on the current route (same logic as mlm/issuance)
    const isActive = Boolean(link && location.pathname === link);
    const onClick = () => {
        navigation(`${link}`);
    }
    return (
        <div className={`header-item mt-2 cursor-pointer ${isActive ? "active" : ""}`} onClick={onClick} >
            <span className="text">{icon}  {name ? name : ""}  </span>
        </div>
    )
}
export default HeaderItem;